import {
  EN_AUTHORIZATION_APPLICATION,
  EN_SOLDERA_MEMBERSHIP,
} from "@/signup/contract_keys";

export type Contract = {
  contract_key: string;
  meta: {
    title: string;
    description: string;
  };
  include: boolean;
  can_include: boolean;
};

export const GENERIC_SOLDERA_MEMBERSHIP_AGREEMENT_CONTRACT: Contract = {
  contract_key: EN_SOLDERA_MEMBERSHIP,
  meta: {
    title:
      "signup.contract_review_component.generic.soldera_membership_agreement_title",
    description:
      "signup.contract_review_component.generic.soldera_membership_agreement_text",
  },
  include: true,
  can_include: true,
};

export const GENERIC_AUTHORIZATION_APPLICATION_CONTRACT: Contract = {
  contract_key: EN_AUTHORIZATION_APPLICATION,
  meta: {
    title:
      "signup.contract_review_component.generic.authorization_application_title",
    description:
      "signup.contract_review_component.generic.authorization_application_text",
  },
  include: true,
  can_include: true,
};

export const GENERIC_CONTRACTS: Contract[] = [
  GENERIC_AUTHORIZATION_APPLICATION_CONTRACT,
  GENERIC_SOLDERA_MEMBERSHIP_AGREEMENT_CONTRACT,
];
